'use client';

import { cn } from '@/lib/utils';
import Image from 'next/image';
import { HTMLAttributes } from 'react';

import {avertaLightItalic, avertaSemibold} from '@/styles/fonts';

interface IUserReviewProps extends HTMLAttributes<HTMLDivElement> {
  title?: string;
  text: string;
  user: string;
  stars: string[];
}

export function UserReview({
  title,
  text,
  user,
  stars,
  className,
}: IUserReviewProps) {
  return (
    <div
      className={cn(
        `flex w-full h-full mx-auto text text-gray-900 flex-wrap overflow-hidden px-10 whitespace-normal flex-col gap-4`,
        className,
      )}>
      <div className="flex">
        {stars.map((star, index) => (
          <Image
            src={`https://villatravellers-prod.s3.eu-west-2.amazonaws.com/assets/images/stars/${star}.svg`}
            alt={star}
            width={18}
            height={18}
            key={index}
            className="mr-1"
          />
        ))}
      </div>

      <blockquote className="w-full text-xl opacity-80 font-averta">
        {text}
      </blockquote>

      <p>
        <strong className="whitespace-normal text-lg font-averta-semibold">
          {user}
        </strong>
      </p>
    </div>
  );
}
